import type { Result } from 'true-myth';

import type { WatchList } from '~/shared/data-contract/watch';
import { watchListSchema } from '~/shared/data-contract/watch';
import type { HttpFetcherWithBaseUrl } from '~/shared/http-fetcher';
import type { HttpFetcherError } from '~/shared/http-fetcher/http-fetcher';
import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

export type WatchesFetchers = {
    readonly listWatches: () => Promise<Result<WatchList, HttpFetcherError>>;
    readonly muteWatch: (itemId: string) => Promise<Result<unknown, HttpFetcherError>>;
    readonly unmuteWatch: (itemId: string) => Promise<Result<unknown, HttpFetcherError>>;
    readonly unwatchItem: (itemId: string) => Promise<Result<unknown, HttpFetcherError>>;
    readonly watchItem: (itemId: string) => Promise<Result<unknown, HttpFetcherError>>;
};

export type WatchesFetchersDependencies = {
    readonly cobrainerApiFetcher: HttpFetcherWithBaseUrl;
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
};

export const createWatchesFetchers = (dependencies: WatchesFetchersDependencies): WatchesFetchers => {
    const { cobrainerApiFetcher, validatingCobrainerApiFetcher } = dependencies;

    const listWatches: WatchesFetchers['listWatches'] = async () => {
        return validatingCobrainerApiFetcher.get(watchListSchema, { pathname: '/watches' });
    };

    const watchItem: WatchesFetchers['watchItem'] = async (itemId) => {
        return cobrainerApiFetcher.put({ pathname: `/watches/${itemId}` });
    };

    const unwatchItem: WatchesFetchers['unwatchItem'] = async (itemId) => {
        return cobrainerApiFetcher.delete({ pathname: `/watches/${itemId}` });
    };

    const muteWatch: WatchesFetchers['muteWatch'] = async (itemId) => {
        return cobrainerApiFetcher.post({ pathname: `/watches/${itemId}/mute` });
    };

    const unmuteWatch: WatchesFetchers['unmuteWatch'] = async (itemId) => {
        return cobrainerApiFetcher.post({ pathname: `/watches/${itemId}/unmute` });
    };

    return {
        listWatches,
        muteWatch,
        unmuteWatch,
        unwatchItem,
        watchItem,
    };
};
